import { render, staticRenderFns } from "./carInfo.vue?vue&type=template&id=655376a9&scoped=true&"
import script from "./carInfo.vue?vue&type=script&lang=js&"
export * from "./carInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655376a9",
  null
  
)

export default component.exports